const KEY = 'beenHere';
const VAL = 'doneThat';

export function beenHereBefore() {
  return window.localStorage && window.localStorage.getItem(KEY) === VAL;
}

export function yep() {
  if (beenHereBefore()) {
    return;
  }
  window.localStorage && window.localStorage.setItem(KEY, VAL);
}
